module.exports = __webpack_public_path__ + "static/efreeti_bottle-6140e2d376ebf3b1a2beb2f5722505e6.jpeg";